import {
  Provider,
  ProviderCategory,
  type SourceAccount,
} from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import { useDAL } from './useDAL';
import { useSourceAccounts } from './useSourceAccounts';

const toSortedProviders = (accounts: SourceAccount[] | undefined) =>
  Array.from(
    (accounts || []).reduce((acc, account) => {
      const provider = account.sourceAccountAttributes.cloudProvider;
      if (provider !== Provider.ProviderUnspecified) {
        acc.add(provider);
      }
      return acc;
    }, new Set<Provider>())
  ).sort();

export const useCloudProviders = () => {
  const { sourceAccounts } = useSourceAccounts();

  return useMemo(() => toSortedProviders(sourceAccounts), [sourceAccounts]);
};

export const useCloudAndSaasProviders = () => {
  const dal = useDAL();
  const { data } = dal.cloudAccounts.source.useList(undefined, undefined, {
    filters: {
      providerCategory: {
        _in: [ProviderCategory.CloudPlatform, ProviderCategory.Saas],
      },
    },
  });

  const accounts = data?.accounts;

  return useMemo(
    () => ({
      providers: toSortedProviders(accounts),
      accounts: accounts ?? [],
    }),
    [accounts]
  );
};

export const getAllCloudProviders = (isDemoOrDev: boolean) =>
  Object.values(Provider).filter(
    (x) =>
      x !== Provider.ProviderUnspecified &&
      x !== Provider.GoogleWorkspace &&
      x !== Provider.Microsoft365 &&
      (isDemoOrDev || x !== Provider.MongoAtlas)
  );
